﻿
<ng-container *ngIf="loading">

  <div class="dsk-wrap" style="padding:20px 20px 0">
    <div class="dsk-pulse" style="width:100%;height:160px;border-radius:16px"></div>
  </div>

  <div class="dsk-wrap" *ngIf="isEmployee()">
    <div class="dsk-stat-row">
      <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4]"></div>
    </div>
    <div class="dsk-split dsk-split-1-1" style="align-items:flex-start">
      <div class="dsk-cal">
        <div class="dsk-cal-nav">
          <div class="dsk-cell dsk-pulse" style="width:32px;height:32px;border-radius:8px"></div>
          <div class="dsk-cell dsk-pulse" style="width:130px;height:16px"></div>
          <div class="dsk-cell dsk-pulse" style="width:32px;height:32px;border-radius:8px"></div>
        </div>
        <div class="dsk-cal-grid">
          <div class="dsk-cal-head dsk-pulse" *ngFor="let d of [1,2,3,4,5,6,7]"></div>
          <div class="dsk-cal-cell dsk-pulse" style="height:36px" *ngFor="let c of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35]"></div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:12px">
        <div class="dsk-panel">
          <div class="dsk-panel-head">
            <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
          </div>
          <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;padding:14px">
            <div class="dsk-pulse" style="height:68px;border-radius:10px" *ngFor="let q of [1,2,3,4,5,6]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dsk-wrap" *ngIf="isManager()">
    <div class="dsk-stat-row">
      <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4]"></div>
    </div>
    <div class="dsk-split dsk-split-3-2" style="align-items:flex-start">
      <div class="dsk-panel">
        <div class="dsk-panel-head">
          <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
        </div>
        <div class="dsk-panel-body" style="gap:8px">
          <div class="dsk-list-item dsk-pulse" style="height:54px" *ngFor="let m of [1,2,3,4,5]"></div>
        </div>
      </div>
      <div style="display:flex;flex-direction:column;gap:12px">
        <div class="dsk-pulse" style="height:110px;border-radius:12px"></div>
        <div class="dsk-pulse" style="height:110px;border-radius:12px"></div>
        <div class="dsk-pulse" style="height:110px;border-radius:12px"></div>
      </div>
    </div>
    <div class="dsk-split dsk-split-2-1" style="align-items:flex-start">
      <div class="dsk-pulse" style="height:180px;border-radius:12px"></div>
      <div class="dsk-pulse" style="height:180px;border-radius:12px"></div>
    </div>
  </div>

  <div class="dsk-wrap" *ngIf="isAdmin() || isHR()">
    <div class="dsk-stat-row">
      <div class="dsk-stat dsk-pulse" *ngFor="let s of [1,2,3,4,5]"></div>
    </div>
    <div class="dsk-split dsk-split-2-1" style="align-items:flex-start">
      <div class="dsk-table">
        <div class="dsk-thead">
          <div class="dsk-th dsk-pulse" style="flex:2"></div>
          <div class="dsk-th dsk-pulse" style="flex:1" *ngFor="let h of [1,2,3,4]"></div>
        </div>
        <div class="dsk-tbody">
          <div class="dsk-tr" *ngFor="let r of [1,2,3,4,5,6,7]">
            <div class="dsk-avatar dsk-pulse"></div>
            <div class="dsk-av-lines">
              <div class="dsk-cell dsk-pulse" style="width:100px"></div>
              <div class="dsk-cell dsk-pulse" style="width:65px;height:11px;margin-top:5px"></div>
            </div>
            <div class="dsk-cell dsk-pulse" style="flex:1" *ngFor="let c of [1,2,3,4]"></div>
          </div>
        </div>
      </div>
      <div class="dsk-panel">
        <div class="dsk-panel-head">
          <div class="dsk-cell dsk-pulse" style="flex:1;height:13px"></div>
        </div>
        <div class="dsk-panel-body" style="gap:8px">
          <div *ngFor="let d of [1,2,3,4,5,6]" style="display:flex;align-items:center;gap:10px">
            <div class="dsk-cell dsk-pulse" style="width:90px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="flex:1;height:10px;border-radius:20px"></div>
            <div class="dsk-cell dsk-pulse" style="width:28px;height:13px"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="dsk-split dsk-split-1-1">
      <div class="dsk-pulse" style="height:200px;border-radius:12px"></div>
      <div class="dsk-pulse" style="height:200px;border-radius:12px"></div>
    </div>
  </div>

</ng-container>

<div class="db" *ngIf="!loading">

  <div class="gc-wrap mb16">
    <div class="gc-card">

      <!-- Nature scene: a painted sky/sun/mountains vignette occupying ONLY the top-right
           corner, faded into the white card by a soft radial mask. Every color repaints from
           the time-of-day palette (this.scene) with a slow cross-fade. -->
      <div class="gc-scene" aria-hidden="true" *ngIf="scene">
        <svg viewBox="0 0 480 168" preserveAspectRatio="xMaxYMin slice" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="gcSky" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%"   [attr.stop-color]="scene.skyTop"/>
              <stop offset="50%"  [attr.stop-color]="scene.skyMid"/>
              <stop offset="100%" [attr.stop-color]="scene.skyBot"/>
            </linearGradient>
            <radialGradient id="gcLumGlow" cx="50%" cy="50%" r="50%">
              <stop offset="0%"   [attr.stop-color]="scene.lumCore" stop-opacity="0.5"/>
              <stop offset="100%" [attr.stop-color]="scene.lumCore" stop-opacity="0"/>
            </radialGradient>
          </defs>

          <rect width="480" height="168" fill="url(#gcSky)"/>
          <ellipse cx="382" cy="168" rx="160" ry="80" [attr.fill]="scene.horizonColor" [attr.opacity]="scene.horizonOp"/>

          <circle [attr.cx]="scene.lumX" [attr.cy]="scene.lumY" [attr.r]="scene.lumH3R" fill="url(#gcLumGlow)" [attr.opacity]="scene.lumH3Op * 3"/>
          <circle [attr.cx]="scene.lumX" [attr.cy]="scene.lumY" [attr.r]="scene.lumH2R" [attr.fill]="scene.lumH2" [attr.opacity]="scene.lumH2Op"/>
          <circle [attr.cx]="scene.lumX" [attr.cy]="scene.lumY" [attr.r]="scene.lumH1R" [attr.fill]="scene.lumH1" [attr.opacity]="scene.lumH1Op"/>
          <circle class="gc-lum-core" [attr.cx]="scene.lumX" [attr.cy]="scene.lumY" r="13" [attr.fill]="scene.lumCore" opacity="0.95"/>

          <g [attr.transform]="'translate(' + scene.lumX + ',' + scene.lumY + ')'"
             [attr.opacity]="scene.raysOp" [attr.stroke]="scene.raysColor" stroke-width="1" stroke-linecap="round">
            <line x1="0" y1="-32" x2="0" y2="-22"/><line x1="0" y1="22" x2="0" y2="32"/>
            <line x1="-32" y1="0" x2="-22" y2="0"/><line x1="22" y1="0" x2="32" y2="0"/>
            <line x1="-22" y1="-22" x2="-28" y2="-28"/><line x1="22" y1="22" x2="28" y2="28"/>
            <line x1="22" y1="-22" x2="28" y2="-28"/><line x1="-22" y1="22" x2="-28" y2="28"/>
          </g>

          <circle [attr.cx]="scene.lumX + 8" [attr.cy]="scene.lumY - 6" r="11"
                  [attr.fill]="scene.skyTop" [attr.opacity]="scene.moonOp"/>

          <g class="gc-svg-stars" [attr.opacity]="scene.starsOp" fill="#ffffff">
            <circle cx="250" cy="14" r="1"/><circle cx="284" cy="8" r="0.8"/>
            <circle cx="316" cy="20" r="1.1"/><circle cx="340" cy="10" r="0.7"/>
            <circle cx="272" cy="30" r="0.7"/><circle cx="440" cy="12" r="0.8"/>
            <circle cx="462" cy="24" r="0.6"/><circle cx="424" cy="20" r="1"/>
          </g>

          <g class="gc-cloud-a" [attr.opacity]="scene.cloudsAOp">
            <ellipse cx="290" cy="30" rx="44" ry="12" [attr.fill]="scene.cloudsATint"/>
            <ellipse cx="315" cy="24" rx="28" ry="11" [attr.fill]="scene.cloudsATint"/>
            <ellipse cx="268" cy="32" rx="24" ry="8"  [attr.fill]="scene.cloudsATint"/>
          </g>
          <g class="gc-cloud-b" [attr.opacity]="scene.cloudsBOp">
            <ellipse cx="435" cy="74" rx="36" ry="10" [attr.fill]="scene.cloudsBTint"/>
            <ellipse cx="456" cy="68" rx="22" ry="8"  [attr.fill]="scene.cloudsBTint"/>
          </g>
          <g class="gc-cloud-c" [attr.opacity]="scene.cloudsCOp">
            <ellipse cx="246" cy="48" rx="32" ry="7" [attr.fill]="scene.cloudsCTint"/>
            <ellipse cx="266" cy="44" rx="20" ry="6" [attr.fill]="scene.cloudsCTint"/>
          </g>

          <polygon points="220,168 268,100 308,130 358,84 404,112 446,78 480,96 480,168"
                   [attr.fill]="scene.mtnFarColor" [attr.opacity]="scene.mtnFarOp"/>
          <polygon points="220,168 258,118 292,138 338,104 384,128 430,97 470,118 480,115 480,168"
                   [attr.fill]="scene.mtnMidColor" [attr.opacity]="scene.mtnMidOp"/>
          <polygon points="220,168 254,136 288,148 324,122 360,140 402,116 442,138 480,128 480,168"
                   [attr.fill]="scene.mtnNearColor" [attr.opacity]="scene.mtnNearOp"/>
          <path d="M220,168 Q278,148 340,154 Q402,144 480,152 L480,168Z"
                [attr.fill]="scene.hillsColor" [attr.opacity]="scene.hillsOp"/>

          <g class="gc-birds-a" [attr.opacity]="scene.birdsAOp" stroke="#ffffff" stroke-width="1.2" fill="none" stroke-linecap="round">
            <path d="M303 52 Q307 48 311 52"/>
            <path d="M317 45 Q322 41 327 45"/>
            <path d="M294 58 Q298 55 302 58"/>
          </g>
          <g class="gc-birds-b" [attr.opacity]="scene.birdsBOp" stroke="#ffffff" stroke-width="1" fill="none" stroke-linecap="round">
            <path d="M442 48 Q446 44 450 48"/>
            <path d="M454 42 Q458 38 462 42"/>
          </g>

          <g [attr.opacity]="scene.treesOp" [attr.fill]="scene.hillsColor">
            <polygon points="473,168 473,130 466,130 473,110 480,130 473,130"/>
            <rect x="472" y="130" width="2" height="38"/>
            <polygon points="462,168 462,138 456,138 462,120 468,138 462,138"/>
            <rect x="461" y="138" width="2" height="30"/>
          </g>
        </svg>
      </div>

      <div class="gc-grain" aria-hidden="true"></div>

      <div class="gc-overlay"></div>

      <div class="gc-clock" [style.color]="greetingAccent.color">
        <mat-icon>schedule</mat-icon>{{ greetingClock }}
      </div>

      <div class="gc-content">

        <div class="gc-id">
          <div class="gc-pills">
            <span class="gc-pill">{{ (currentUser.designation || currentUser.role) | uppercase }}</span>
            <span class="gc-pill">{{ currentUser.department || 'HQ' }}</span>
            <span class="gc-pill gc-pill--client" *ngIf="myClientName"><mat-icon>business_center</mat-icon> {{ myClientName }}</span>
            <span class="gc-pill gc-pill--project" *ngIf="myProjectName"><mat-icon>folder_special</mat-icon> {{ myProjectName }}</span>
            <span class="gc-pill gc-pill--mode" *ngIf="myWorkMode">{{ myWorkMode }}</span>
            <span class="gc-pill gc-pill--shift" *ngIf="myShiftLabel"><mat-icon>schedule</mat-icon> {{ myShiftLabel }}</span>
          </div>

          <div class="gc-greeting" [style.color]="greetingAccent.color">
            <span class="gc-greeting-ic" [style.background]="greetingAccent.chipBg">
              <mat-icon [style.color]="greetingAccent.color">{{ greetingAccent.icon }}</mat-icon>
            </span>
            <span>{{ greetingLabel }},<br>{{ currentUser.firstName }}</span>
          </div>
        </div>

        <div class="gc-divider"></div>

        <div class="gc-quote-col">
          <div class="gc-quote-area" (click)="nextGreetingQuote()" title="Click for another quote">
            <p class="gc-quote" [attr.data-key]="greetingQuoteIdx">&ldquo;{{ greetingQuote.text }}&rdquo;</p>
            <div class="gc-quote-foot">
              <span class="gc-quote-author">{{ greetingQuote.author }}</span>
              <mat-icon class="gc-quote-next">chevron_right</mat-icon>
              <span class="gc-sticker" [style.color]="greetingAccent.color" [style.background]="greetingAccent.chipBg">{{ greetingSticker }}</span>
            </div>
          </div>

          <div class="gc-progress-track">
            <div class="gc-progress-fill" [class.gc-progress-running]="progressRunning"
                 [style.background]="greetingAccent.color"></div>
          </div>
        </div>

        <div class="gc-right" *ngIf="myManager">
          <div class="gc-mgr-card">
            <div class="gc-mgr-label">
              <mat-icon>supervisor_account</mat-icon> Reporting Manager
            </div>
            <div class="gc-mgr-body">
              <div class="gc-mgr-avatar">
                <img *ngIf="myManager.photo" [src]="myManager.photo" [alt]="myManager.name" class="gc-mgr-photo">
                <span *ngIf="!myManager.photo" [style.background]="myManager.avatarColor">{{ myManager.initials }}</span>
              </div>
              <div class="gc-mgr-info">
                <div class="gc-mgr-id">{{ myManager.employeeId }}</div>
                <div class="gc-mgr-name">{{ myManager.name }}</div>
                <div class="gc-mgr-role">{{ myManager.role }}</div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>

  <ng-container *ngIf="isAdmin()">
    <div class="adm-stat-row">

      <div class="adm-card adm-card-border-maroon adm-card-click" (click)="navigateTo('/employees')" title="Open employee directory">
        <div class="adm-sc-head">
          <span class="adm-sc-label">TOTAL EMPLOYEES</span>
          <div class="adm-sc-icon-wrap"><mat-icon class="adm-sc-icon">groups</mat-icon></div>
        </div>
        <div class="adm-sc-num">{{ totalEmployees }}</div>
        <div class="adm-sc-bottom">
          <span class="adm-sc-sub">Active headcount</span>
          <div class="adm-sc-pill adm-pill-green"><mat-icon class="adm-pill-icon">trending_up</mat-icon>+{{ newThisMonth }} this month</div>
        </div>
      </div>

      <div class="adm-card adm-card-border-green adm-card-click" (click)="navigateTo('/attendance', { tab: 'admin', status: 'present' })" title="See today's present list">
        <div class="adm-sc-head">
          <span class="adm-sc-label">PRESENT TODAY</span>
          <div class="adm-sc-icon-wrap"><mat-icon class="adm-sc-icon">how_to_reg</mat-icon></div>
        </div>
        <div class="adm-sc-num">
          {{ presentToday }}<span class="adm-sc-of">/ {{ totalEmployees }}</span>
        </div>
        <div class="adm-present-bar-track">
          <div class="adm-present-bar-fill adm-bar-green" [style.width.%]="totalEmployees > 0 ? (presentToday * 100 / totalEmployees) : 0"></div>
        </div>
        <div class="adm-sc-bottom">
          <span class="adm-sc-sub">{{ totalEmployees > 0 ? (presentToday * 100 / totalEmployees | number:'1.0-0') : 0 }}% attendance rate</span>
        </div>
      </div>

      <div class="adm-card adm-card-border-amber adm-card-click" (click)="navigateTo('/leaves')" title="Review pending leave requests">
        <div class="adm-alert-dot" *ngIf="pendingLeaveCount > 0">!</div>
        <div class="adm-sc-head">
          <span class="adm-sc-label">PENDING LEAVES</span>
          <div class="adm-sc-icon-wrap"><mat-icon class="adm-sc-icon">pending_actions</mat-icon></div>
        </div>
        <div class="adm-sc-num">
          {{ pendingLeaveCount }}<span class="adm-sc-of">requests</span>
        </div>
        <div class="adm-sc-bottom">
          <span class="adm-sc-sub">Awaiting your approval</span>
          <div class="adm-sc-pill adm-pill-amber"><mat-icon class="adm-pill-icon">hourglass_empty</mat-icon>Requires attention</div>
        </div>
      </div>

      <div class="adm-card adm-card-border-blue adm-card-click" (click)="navigateTo('/onboarding')" title="Open onboarding">
        <div class="adm-sc-head">
          <span class="adm-sc-label">NEW JOINERS</span>
          <div class="adm-sc-icon-wrap"><mat-icon class="adm-sc-icon">person_add</mat-icon></div>
        </div>
        <div class="adm-sc-num">
          {{ newThisMonth }}<span class="adm-sc-of">this month</span>
        </div>
        <div class="adm-sc-bottom">
          <span class="adm-sc-sub">Onboarding in progress</span>
          <div class="adm-sc-pill adm-pill-blue"><mat-icon class="adm-pill-icon">celebration</mat-icon>Welcome aboard</div>
        </div>
      </div>

    </div>
  </ng-container>

  <app-announcement-widget></app-announcement-widget>

  <!-- Non-admin roles keep this right after the announcement; the admin dashboard moves it
       below the Real-Time Attendance / Department Headcount grid instead (see adm-mid-row). -->
  <app-pulse-widget *ngIf="!isAdmin()"></app-pulse-widget>

  <ng-container *ngIf="isEmployee()">

    <div class="dash-alloc" *ngIf="myAllocations.length">
      <div class="dash-alloc-head"><mat-icon>business_center</mat-icon> My Client Allocation</div>
      <div class="dash-alloc-list">
        <div class="dash-alloc-item" *ngFor="let a of myAllocations">
          <span class="dash-alloc-client">{{ a.client || 'Internal' }}</span>
          <ng-container *ngIf="a.project">
            <mat-icon class="dash-alloc-arrow">chevron_right</mat-icon>
            <span class="dash-alloc-proj">{{ a.project }}</span>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="stat-row">
      <div class="stat-card sc-maroon">
        <div class="sc-top">
          <span class="sc-label">PRESENT THIS MONTH</span>
          <div class="sc-ic"><mat-icon>event_available</mat-icon></div>
        </div>
        <div class="sc-value">{{ myDaysPresent }}</div>
        <div class="sc-bottom">
          <span class="sc-sub">Days attended</span>
          <div class="sc-footer"><span class="sc-tag sc-tag-green">{{ getWorkingDaysInMonth() }} working days</span></div>
        </div>
      </div>
      <div class="stat-card sc-green">
        <div class="sc-top">
          <span class="sc-label">LEAVE BALANCE</span>
          <div class="sc-ic"><mat-icon>event_note</mat-icon></div>
        </div>
        <div class="sc-value">{{ myTotalLeaveBalance }}</div>
        <div class="sc-bottom">
          <span class="sc-sub">
            <ng-container *ngFor="let lb of myLeaveBalanceSummary; let last = last">{{ lb.label }} {{ lb.remaining }}<ng-container *ngIf="!last"> · </ng-container></ng-container>
            <ng-container *ngIf="myLeaveBalanceSummary.length === 0">No data</ng-container>
          </span>
          <div class="sc-footer"><span class="sc-tag sc-tag-blue">Available</span></div>
        </div>
      </div>
      <div class="stat-card sc-dgreen">
        <div class="sc-top">
          <span class="sc-label">TODAY'S WORK TIME</span>
          <div class="sc-ic"><mat-icon>timer</mat-icon></div>
        </div>
        <div class="sc-timer">{{ workTimerDisplay }}</div>
        <div class="sc-bottom">
          <span class="sc-sub">{{ myAttendance?.checkIn ? ('In · ' + checkInTime) : 'Not checked in' }}</span>
          <div class="sc-footer">
            <span class="sc-tag sc-tag-teal" *ngIf="myAttendance?.checkIn">Active</span>
            <span class="sc-tag sc-tag-amber" *ngIf="!myAttendance?.checkIn">Not clocked in</span>
          </div>
        </div>
        <button type="button" class="sc-clock-btn"
                [class.sc-clock-btn--out]="isCheckedIn"
                [disabled]="checkingIn || checkingOut"
                (click)="isCheckedIn ? checkOut() : checkIn()">
          <mat-icon>{{ isCheckedIn ? 'logout' : 'login' }}</mat-icon>
          {{ checkingIn ? 'Checking in…' : (checkingOut ? 'Checking out…' : (isCheckedIn ? 'Check Out' : 'Check In')) }}
        </button>
      </div>
      <div class="stat-card sc-blue">
        <div class="sc-top">
          <span class="sc-label">PENDING LEAVES</span>
          <div class="sc-ic"><mat-icon>pending_actions</mat-icon></div>
        </div>
        <div class="sc-value">{{ myPendingLeaveCount }}</div>
        <div class="sc-bottom">
          <span class="sc-sub">{{ myLeaves.length }} total requests</span>
          <div class="sc-footer">
            <span class="sc-tag sc-tag-amber" *ngIf="myPendingLeaveCount > 0">Pending</span>
            <span class="sc-tag sc-tag-green" *ngIf="myPendingLeaveCount === 0">None pending</span>
          </div>
        </div>
      </div>
    </div>

    <div class="emp-row3">
      <div class="card cal-card">
        <div class="cal-header">
          <div class="ch">My Attendance — {{ calendarMonth.split(" ")[0] }}</div>
          <div class="cal-nav">
            <button (click)="prevMonth()">‹</button>
            <div class="cal-month">{{ calendarMonth }}</div>
            <button (click)="nextMonth()">›</button>
          </div>
        </div>
        <table class="cal-table">
          <thead><tr><th>SUN</th><th>MON</th><th>TUE</th><th>WED</th><th>THU</th><th>FRI</th><th>SAT</th></tr></thead>
          <tbody>
            <tr *ngFor="let week of calendarWeeks">
              <td *ngFor="let cell of week" [class.other-month]="!cell.current" [class.today]="cell.isToday"
                  [class.cal-selected]="cell.current && calSelectedDate && calSelectedDate.endsWith('-' + (cell.day < 10 ? '0' : '') + cell.day)"
                  (click)="selectCalDay(cell)" style="cursor:pointer">
                <span class="cal-day" [ngClass]="cell.status">{{ cell.day }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="cal-detail" *ngIf="calSelectedDate">
          <div class="cal-detail-date">{{ calSelectedDate | date:'EEE, MMM d' }}</div>
          <ng-container *ngIf="calSelectedRecord; else noRecord">
            <div class="cal-detail-row">
              <mat-icon class="cal-di-icon">login</mat-icon>
              <span class="cal-di-label">Check-in</span>
              <span class="cal-di-val">{{ formatTime(calSelectedRecord.checkIn || calSelectedRecord.checkInTime, calSelectedRecord.date) }}</span>
            </div>
            <div class="cal-detail-row" *ngIf="calCheckInLocation">
              <mat-icon class="cal-di-icon">place</mat-icon>
              <span class="cal-di-label">In location</span>
              <span class="cal-di-val cal-di-loc">{{ calCheckInLocation }}</span>
            </div>
            <div class="cal-detail-row" *ngIf="!calCheckInLocation && (calSelectedRecord.location || calSelectedRecord.checkInLocation)">
              <mat-icon class="cal-di-icon">place</mat-icon>
              <span class="cal-di-label">In location</span>
              <span class="cal-di-val cal-di-loc">{{ calSelectedRecord.location || calSelectedRecord.checkInLocation }}</span>
            </div>
            <div class="cal-detail-row">
              <mat-icon class="cal-di-icon">logout</mat-icon>
              <span class="cal-di-label">Check-out</span>
              <span class="cal-di-val">{{ formatTime(calSelectedRecord.checkOut || calSelectedRecord.checkOutTime, calSelectedRecord.date) || '—' }}</span>
            </div>
            <div class="cal-detail-row" *ngIf="calCheckOutLocation">
              <mat-icon class="cal-di-icon">place</mat-icon>
              <span class="cal-di-label">Out location</span>
              <span class="cal-di-val cal-di-loc">{{ calCheckOutLocation }}</span>
            </div>
          </ng-container>
          <ng-template #noRecord>
            <ng-container *ngIf="calSelectedStatus === 'absent'; else noAbsent">
              <div class="cal-absent-msg">No attendance record for this day</div>
              <div class="cal-absent-actions">
                <button class="cal-act-btn cal-act-leave" (click)="navigateTo('/leaves', {prefillDate: calSelectedDate})">
                  <mat-icon>event_note</mat-icon> Apply Leave
                </button>
                <button class="cal-act-btn cal-act-reg" (click)="navigateTo('/attendance', {prefillDate: calSelectedDate, tab: 'regularise'})">
                  <mat-icon>timer</mat-icon> Regularise
                </button>
              </div>
            </ng-container>
            <ng-template #noAbsent>
              <div class="cal-detail-empty">No attendance record for this day</div>
            </ng-template>
          </ng-template>
        </div>
        <div class="cal-legend">
          <span class="cl-item"><span class="cl-dot present"></span>Present</span>
          <span class="cl-item"><span class="cl-dot absent"></span>Absent</span>
          <span class="cl-item"><span class="cl-dot leave"></span>Leave</span>
          <span class="cl-item"><span class="cl-dot holiday"></span>Holiday</span>
          <span class="cl-item"><span class="cl-dot weekend"></span>Weekend</span>
        </div>
      </div>
      <div class="card qa-card">
        <div class="ch">Quick Actions</div>
        <div class="qa-grid">
          <button class="qa-btn qa-amber" (click)="navigateTo('/leaves')"><mat-icon>event_note</mat-icon> Apply Leave</button>
          <button class="qa-btn qa-amber" (click)="navigateTo('/attendance')"><mat-icon>timer</mat-icon> Regularise</button>
          <button class="qa-btn qa-outline" (click)="navigateTo('/profile')"><mat-icon>person_outline</mat-icon> My Profile</button>
          <button class="qa-btn qa-outline" (click)="navigateTo('/my-payslips')"><mat-icon>receipt_long</mat-icon> My Payslips</button>
        </div>
        <div class="ch" style="margin-top:18px;margin-bottom:8px;font-size:13px">Recent Leave Updates</div>
        <div class="ru-list">
          <div class="ru-item" *ngFor="let l of myLeaves.slice(0, 3)">
            <div class="ru-ic" [ngClass]="l.status">
              <mat-icon *ngIf="l.status === 'approved'" style="font-size:14px;width:14px;height:14px">check_circle</mat-icon>
              <mat-icon *ngIf="l.status !== 'approved'" style="font-size:14px;width:14px;height:14px">hourglass_empty</mat-icon>
            </div>
            <div class="ru-info">
              <div class="ru-title">{{ l.leaveType | titlecase }} Leave — {{ l.status | titlecase }}</div>
              <div class="ru-sub">{{ l.startDate }} –{{ l.endDate }}</div>
            </div>
          </div>
          <div class="ru-item" *ngIf="myLeaves.length === 0">
            <div class="ru-info"><div class="ru-sub">No recent updates</div></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="todayBirthdays.length > 0" style="margin-top:16px;padding:16px 20px">
      <div class="ch" style="margin-bottom:10px"><mat-icon style="vertical-align:middle;margin-right:6px;color:#e91e8c">cake</mat-icon>Birthdays Today</div>
      <div class="ru-list">
        <div class="ru-item" *ngFor="let emp of todayBirthdays">
          <div class="ru-ic" style="background:rgba(233,30,140,.12);color:#e91e8c">
            <mat-icon style="font-size:14px;width:14px;height:14px">cake</mat-icon>
          </div>
          <div class="ru-info">
            <div class="ru-title">{{ emp.firstName }} {{ emp.lastName }}</div>
            <div class="ru-sub">{{ emp.designation || emp.title || emp.departmentName || '' }} · Happy Birthday! ðŸŽ‚</div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="isManager()">

    <div class="mstat-row mb16">
      <div class="mstat mstat-click" (click)="navigateTo('/my-team')" title="Open team profiles">
        <div class="mstat-ic mic-slate"><mat-icon>groups</mat-icon></div>
        <div class="mstat-body">
          <span class="mstat-val">{{ teamSize }}</span>
          <span class="mstat-lbl">Team Size</span>
          <span class="mstat-sub">Active reportees</span>
        </div>
      </div>
      <div class="mstat mstat-click" (click)="navigateTo('/attendance', { tab: 'admin', status: 'present' })" title="See today's present list">
        <div class="mstat-ic mic-green"><mat-icon>check_circle</mat-icon></div>
        <div class="mstat-body">
          <span class="mstat-val">{{ teamPresentToday }}<span class="mstat-of">/ {{ teamSize }}</span></span>
          <span class="mstat-lbl">Present Today</span>
          <span class="mstat-sub">{{ teamSize > 0 ? (teamPresentToday * 100 / teamSize | number:'1.0-0') : 0 }}% present</span>
        </div>
      </div>
      <div class="mstat mstat-click" (click)="navigateTo('/attendance', { tab: 'admin', status: 'on-leave' })" title="See who is on leave today">
        <div class="mstat-ic mic-amber"><mat-icon>event_note</mat-icon></div>
        <div class="mstat-body">
          <span class="mstat-val">{{ teamOnLeave }}</span>
          <span class="mstat-lbl">On Leave</span>
          <span class="mstat-sub">Approved &amp; away</span>
        </div>
      </div>
      <div class="mstat mstat-click" [class.mstat--alert]="teamNeedsAttention > 0"
           (click)="navigateTo('/attendance', { tab: 'admin', status: teamAbsent > 0 ? 'absent' : 'late' })" title="See absent / late records">
        <div class="mstat-ic" [class.mic-red]="teamNeedsAttention > 0" [class.mic-slate]="teamNeedsAttention === 0">
          <mat-icon>{{ teamNeedsAttention > 0 ? 'warning_amber' : 'task_alt' }}</mat-icon>
        </div>
        <div class="mstat-body">
          <span class="mstat-val">{{ teamNeedsAttention }}</span>
          <span class="mstat-lbl">Needs Attention</span>
          <span class="mstat-sub">{{ teamAbsent }} absent · {{ teamLate }} late</span>
        </div>
      </div>
    </div>

    <div class="mgr-main-row mb16">

      <div class="mgr-left-col">
      <div class="card">
        <div class="ch">{{ myTeams.length > 0 ? myTeams[0].name : 'My Team' }}{{ myTeams.length > 1 ? ' +' + (myTeams.length - 1) : '' }} — Live Status
          <span class="ch-link" (click)="navigateTo('/my-team')">Full Log →</span>
        </div>

        <div class="ls-summary" *ngIf="teamSize > 0">
          <span class="ls-chip ls-chip-green" [class.on]="teamLiveFilter === 'On Time'" (click)="setTeamLiveFilter('On Time')"><b>{{ teamOnTimeCount }}</b> On time</span>
          <span class="ls-chip ls-chip-amber" [class.on]="teamLiveFilter === 'Late'" (click)="setTeamLiveFilter('Late')"><b>{{ teamLate }}</b> Late</span>
          <span class="ls-chip ls-chip-red" [class.on]="teamLiveFilter === 'Absent'" (click)="setTeamLiveFilter('Absent')"><b>{{ teamAbsent }}</b> Absent</span>
          <span class="ls-chip ls-chip-blue" [class.on]="teamLiveFilter === 'On Leave'" (click)="setTeamLiveFilter('On Leave')"><b>{{ teamOnLeave }}</b> Leave</span>
          <span class="ls-filter-clear" *ngIf="teamLiveFilter" (click)="setTeamLiveFilter('')">Clear filter ×</span>
        </div>

        <div class="ls-scroll-region" *ngIf="teamSize > 0">
        <div class="ls-table">
          <div class="ls-row" *ngFor="let s of teamLiveVisible; trackBy: trackByMember"
               [class.ls-row-alert]="s.status === 'Absent' || s.status === 'Late'">
            <div class="ls-av" [style.background]="getAvatarColor(s.member.firstName)">
              {{ (s.member.firstName?.charAt(0)||'') + (s.member.lastName?.charAt(0)||'') | uppercase }}
            </div>
            <div class="ls-who">
              <span class="ls-name">{{ s.member.firstName }} {{ s.member.lastName }}
                <span class="live-role-badge" *ngIf="s.isLead">Lead</span>
              </span>
              <span class="ls-detail">{{ s.detail }}</span>
            </div>
            <span class="ls-pill" [ngClass]="s.statusClass">{{ s.status }}</span>
            <button class="ls-mark" *ngIf="s.status === 'Absent'"
              (click)="navigateTo('/attendance', { tab: 'regularise', subTab: 'team', employeeId: s.member.id, date: todayStr })">Mark</button>
          </div>
        </div>
        </div>

        <div class="no-rows" *ngIf="teamSize === 0">No team members found.</div>
      </div>

      <div class="card">
        <div class="ch">Work Hours Today
          <span class="ch-sub">{{ teamStillWorkingCount }} on the clock · {{ teamCheckedOutCount }} done</span>
        </div>
        <div class="card-scroll card-scroll-sm" *ngIf="teamHoursToday.length">
          <div class="ls-row" *ngFor="let x of teamHoursToday; trackBy: trackByMember">
            <div class="ls-av" [style.background]="getAvatarColor(x.member.firstName)">
              {{ (x.member.firstName?.charAt(0)||'') + (x.member.lastName?.charAt(0)||'') | uppercase }}
            </div>
            <div class="ls-who">
              <span class="ls-name">{{ x.member.firstName }} {{ x.member.lastName }}</span>
              <span class="ls-detail">{{ x.hours }} worked</span>
            </div>
            <span class="ls-pill" [ngClass]="x.working ? 'status-ontime' : 'status-leave'">{{ x.working ? 'Working' : 'Checked Out' }}</span>
          </div>
        </div>
        <div class="pa-empty" *ngIf="!teamHoursToday.length"><mat-icon>schedule</mat-icon> No check-ins yet today</div>
      </div>
      </div>

      <div class="mgr-right-col">

        <div class="card">
          <div class="ch">Leave Approvals
            <span class="pa-badge" *ngIf="teamPendingLeaves.length > 0">{{ teamPendingLeaves.length }} Pending</span>
          </div>
          <div class="card-scroll">
          <div class="leave-appr-item" *ngFor="let l of teamPendingLeaves">
            <div class="live-av" [style.background]="getAvatarColor(getEmployeeName(l.employeeId))">
              {{ getEmployeeInitials(l.employeeId) }}
            </div>
            <div class="leave-appr-info">
              <div class="leave-appr-name">{{ getEmployeeName(l.employeeId) }}</div>
              <div class="leave-appr-sub">
                {{ l.leaveType | titlecase }} · {{ l.startDate }} –{{ l.endDate }}
              </div>
              <div class="leave-appr-bal" *ngIf="getLeaveDays(l)">{{ getLeaveDays(l) }} days</div>
            </div>
            <div class="leave-appr-btns">
              <button class="appr-btn approve" (click)="approveLeave(l)"><mat-icon>check</mat-icon> Approve</button>
              <button class="appr-btn reject" (click)="rejectLeave(l)"><mat-icon>close</mat-icon> Reject</button>
            </div>
          </div>
          <div class="pa-empty" *ngIf="teamPendingLeaves.length === 0"><mat-icon>task_alt</mat-icon> All caught up — no pending leave requests</div>
          </div>
        </div>

        <div class="card">
          <div class="ch">Regularisation Requests
            <span class="pa-badge" *ngIf="teamPendingRegularisations.length > 0">{{ teamPendingRegularisations.length }} Pending</span>
          </div>
          <div class="card-scroll">
          <div class="leave-appr-item" *ngFor="let r of teamPendingRegularisations">
            <div class="live-av" [style.background]="getAvatarColor(getEmployeeName(r.employeeId))">
              {{ getEmployeeInitials(r.employeeId) }}
            </div>
            <div class="leave-appr-info">
              <div class="leave-appr-name">{{ getEmployeeName(r.employeeId) }}</div>
              <div class="leave-appr-sub">{{ r.date }}<span *ngIf="r.reason"> · {{ r.reason }}</span></div>
            </div>
            <div class="leave-appr-btns">
              <button class="appr-btn approve" (click)="approveRegularisation(r)"><mat-icon>check</mat-icon> Approve</button>
              <button class="appr-btn reject" (click)="rejectRegularisation(r)"><mat-icon>close</mat-icon> Reject</button>
            </div>
          </div>
          <div class="pa-empty" *ngIf="teamPendingRegularisations.length === 0"><mat-icon>task_alt</mat-icon> All caught up — no regularisation requests</div>
          </div>
        </div>

        <div class="card">
          <div class="ch">Shift Coverage Today</div>

          <div class="shift-matrix" *ngIf="shiftCoverageToday.length > 0">
            <div class="shift-tile" *ngFor="let s of shiftCoverageToday.slice(0, 4)">
              <div class="shift-tile-top">
                <span class="shift-tile-name">
                  <span class="shift-dot" [style.background]="s.shift.color"></span>{{ s.shift.name }}
                </span>
                <span class="shift-tile-pct" [class.pct-low]="s.pct < 50">{{ s.pct }}%</span>
              </div>
              <div class="shift-tile-sub">{{ s.present }} / {{ s.assigned }} present</div>
              <div class="shift-tile-bar">
                <i [style.width.%]="s.pct"
                   [style.background]="s.pct < 50 ? '#b45309' : (s.shift.color || '#166534')"></i>
              </div>
            </div>
          </div>
          <div class="pa-empty" *ngIf="shiftCoverageToday.length === 0">No shift assignments found</div>

          <div class="ch" style="margin-top:14px; border-top:1px solid #ede6dc; padding-top:14px">Late Marks — This Week</div>
          <div class="late-mark-row" *ngFor="let s of teamLateList">
            <span class="late-name">{{ s.member.firstName }} {{ s.member.lastName }}</span>
            <span class="late-tag">1 late</span>
          </div>
          <div class="late-mark-row" *ngIf="teamLate === 0">
            <span class="late-name" style="color:#6b4a3a">Others ({{ teamSize }})</span>
            <span class="no-late-tag">No late marks</span>
          </div>
        </div>

      </div>
    </div>

    <div class="mgr-bottom-row">

      <div class="card">
        <div class="ch">Team Attendance — This Week
          <span class="ch-sub">{{ calendarMonth }}</span>
        </div>
        <div class="week-scroll" *ngIf="teamWeeklyRows.length > 0">
          <table class="weekly-grid-table">
            <thead>
              <tr>
                <th>MEMBER</th>
                <th *ngFor="let h of weeklyDayHeaders">{{ h.label }} {{ h.dayNum }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of teamWeeklyRows; trackBy: trackByMember">
                <td>
                  <div class="tdn">
                    <div class="av" [style.background]="getAvatarColor(row.member.firstName)">
                      {{ (row.member.firstName?.charAt(0)||'') + (row.member.lastName?.charAt(0)||'') | uppercase }}
                    </div>
                    <span class="td-name">{{ row.member.firstName }} {{ row.member.lastName }}</span>
                  </div>
                </td>
                <td *ngFor="let d of row.days">
                  <span class="wg-cell" [ngClass]="d.cls">{{ d.label }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pa-empty" *ngIf="teamWeeklyRows.length === 0">Loading team weekly data...</div>
        <div class="wg-legend">
          <span class="wg-leg-item"><span class="wg-cell td-present" style="display:inline-flex;font-size:10px">P</span>Present</span>
          <span class="wg-leg-item"><span class="wg-cell td-absent" style="display:inline-flex;font-size:10px">A</span>Absent</span>
          <span class="wg-leg-item"><span class="wg-cell td-leave" style="display:inline-flex;font-size:10px">LV</span>Leave</span>
          <span class="wg-leg-item"><span class="wg-cell td-late" style="display:inline-flex;font-size:10px">L</span>Late</span>
          <div class="live-more" style="margin-left: auto;" (click)="navigateTo('/my-team')">View full attendance log →</div>
        </div>
      </div>

      <div class="mgr-bottom-right">

        <div class="card">
          <div class="ch">Upcoming Team Leaves
            <span style="font-size:11px;color:#c97d10;font-weight:600">Next 14 days</span>
          </div>
          <div class="card-scroll card-scroll-sm">
          <div class="upcoming-leave-item" *ngFor="let l of teamUpcomingLeaves">
            <div class="upl-info">
              <div class="upl-name">{{ getEmployeeName(l.employeeId) }}</div>
              <div class="upl-sub">{{ l.leaveType | titlecase }} · {{ l.startDate }} –{{ l.endDate }}</div>
            </div>
            <span class="upl-badge" [class.pending]="l.status === 'pending'" [class.approved]="l.status === 'approved'">
              {{ l.status | titlecase }}
            </span>
          </div>
          <div class="pa-empty" *ngIf="teamUpcomingLeaves.length === 0"><mat-icon>event_available</mat-icon> No upcoming team leaves</div>
          </div>
        </div>

        <div class="card">
          <div class="ch">My Quick Actions</div>
          <div class="qa-grid">
            <button class="qa-btn qa-amber" (click)="navigateTo('/attendance')"><mat-icon>timer</mat-icon> My Attendance</button>
            <button class="qa-btn qa-amber" (click)="navigateTo('/leaves')"><mat-icon>event_note</mat-icon> Apply Leave</button>
            <button class="qa-btn qa-outline" (click)="navigateTo('/my-team')"><mat-icon>groups</mat-icon> Team Profiles</button>
            <button class="qa-btn qa-outline" (click)="navigateTo('/profile')"><mat-icon>person_outline</mat-icon> My Profile</button>
          </div>
        </div>

      </div>
    </div>


  </ng-container>

  <ng-container *ngIf="isAdmin()">

    <div class="adm-mid-row">

      <div class="adm-card adm-card-no-border">
        <div class="adm-ch">
          <span class="adm-ch-title">Real-Time Attendance</span>
          <span class="adm-ch-link" (click)="navigateTo('/attendance', {tab:'admin'})">View All</span>
        </div>
        <div class="tw adm-att-scroll-wrap">
          <table class="adm-table adm-att-table">
            <thead>
              <tr>
                <th>EMPLOYEE</th>
                <th>DEPARTMENT</th>
                <th>STATUS</th>
                <th>TIME</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let a of distinctAttendance">
                <td>
                  <div class="tdn">
                    <div class="av" [style.background]="getAvatarColor(getEmployeeName(a.employeeId))">{{ getEmployeeInitials(a.employeeId) }}</div>
                    <span class="td-name">{{ getEmployeeName(a.employeeId) }}</span>
                  </div>
                </td>
                <td class="adm-td-sub">{{ getDeptName(a.departmentId) }}</td>
                <td>
                  <span class="adm-status-pill"
                    [class.adm-status-present]="getAttendanceStatus(a) === 'On Time' || getAttendanceStatus(a) === 'Present'"
                    [class.adm-status-late]="getAttendanceStatus(a) === 'Late'"
                    [class.adm-status-absent]="getAttendanceStatus(a) === 'Absent'"
                    [class.adm-status-leave]="getAttendanceStatus(a) === 'On Leave'">
                    {{ getAttendanceStatus(a) }}
                  </span>
                </td>
                <td class="adm-td-sub">{{ a.checkIn ? formatUtcTime12(a.checkIn, a.date) : '—' }}</td>
              </tr>
              <tr *ngIf="attendance.length === 0">
                <td colspan="4" class="no-rows">No attendance records today</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile: a table is never the right pattern on a narrow phone screen — swap to a
             stacked card list (same data) below 600px instead of forcing a table to scroll. -->
        <div class="adm-att-cards">
          <div class="adm-att-card" *ngFor="let a of distinctAttendance">
            <div class="av" [style.background]="getAvatarColor(getEmployeeName(a.employeeId))">{{ getEmployeeInitials(a.employeeId) }}</div>
            <div class="adm-att-card-mid">
              <div class="td-name">{{ getEmployeeName(a.employeeId) }}</div>
              <div class="adm-td-sub">{{ getDeptName(a.departmentId) }}</div>
            </div>
            <div class="adm-att-card-end">
              <span class="adm-status-pill"
                [class.adm-status-present]="getAttendanceStatus(a) === 'On Time' || getAttendanceStatus(a) === 'Present'"
                [class.adm-status-late]="getAttendanceStatus(a) === 'Late'"
                [class.adm-status-absent]="getAttendanceStatus(a) === 'Absent'"
                [class.adm-status-leave]="getAttendanceStatus(a) === 'On Leave'">
                {{ getAttendanceStatus(a) }}
              </span>
              <span class="adm-att-card-time">{{ a.checkIn ? formatUtcTime12(a.checkIn, a.date) : '—' }}</span>
            </div>
          </div>
          <div class="no-rows" *ngIf="attendance.length === 0">No attendance records today</div>
        </div>
      </div>

      <div class="adm-card adm-card-no-border">
        <div class="adm-ch">
          <span class="adm-ch-title">Department Headcount</span>
        </div>
        <div class="adm-dept-list">
          <div class="adm-dept-item" *ngFor="let d of departments.slice(0, 6)">
            <div class="adm-dept-top">
              <span class="adm-dept-name">{{ d.name }}</span>
              <span class="adm-dept-count">{{ getDeptEmployeeCount(d.id) }}</span>
            </div>
            <div class="adm-bar-track">
              <div class="adm-bar-fill adm-bar-maroon"
                [style.width.%]="totalEmployees > 0 ? (getDeptEmployeeCount(d.id) * 100 / totalEmployees) : 0">
              </div>
            </div>
          </div>
          <div class="pa-empty" *ngIf="departments.length === 0">No departments yet</div>
        </div>
      </div>

    </div>

    <app-pulse-widget></app-pulse-widget>

    <div class="adm-bottom-row">

      <div class="adm-card adm-card-no-border">
        <div class="adm-ch">
          <span class="adm-ch-title">Leave Approvals</span>
          <span class="adm-pending-chip" *ngIf="pendingLeaveCount > 0">{{ pendingLeaveCount }} Pending</span>
        </div>
        <div class="adm-appr-list">
          <div class="adm-appr-item" *ngFor="let l of pendingLeavesList.slice(0, 4)">
            <div class="tdn" style="flex:1;min-width:0">
              <div class="av" [style.background]="getAvatarColor(getEmployeeName(l.employeeId))">{{ getEmployeeInitials(l.employeeId) }}</div>
              <div style="min-width:0">
                <div class="td-name">{{ getEmployeeName(l.employeeId) }}</div>
                <div class="adm-td-sub">{{ l.leaveType | titlecase }} ({{ getLeaveDays(l) }} days)</div>
              </div>
            </div>
            <div class="adm-appr-btns">
              <button class="adm-appr-check" (click)="navigateTo('/leaves')" matTooltip="Approve">
                <mat-icon>check</mat-icon>
              </button>
              <button class="adm-appr-cross" (click)="navigateTo('/leaves')" matTooltip="Reject">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <div class="pa-empty" *ngIf="pendingLeaveCount === 0">All caught up!</div>
        </div>
        <div class="adm-footer-link" (click)="navigateTo('/leaves')">View All Approvals</div>
      </div>

      <div class="adm-card adm-card-no-border">
        <div class="adm-ch">
          <span class="adm-ch-title">Onboarding Progress</span>
          <mat-icon class="adm-sc-icon" style="color:#9e8880;opacity:0.6">person_add</mat-icon>
        </div>
        <div class="adm-onboard-list">
          <button type="button" class="adm-onboard-item adm-onboard-item-click" *ngFor="let emp of newJoinersOnboardedHere.slice(0, 5)"
                  (click)="openOnboardingFor(emp)" title="Open this employee's onboarding checklist">
            <div class="adm-onboard-top">
              <span class="adm-onboard-name">{{ emp.firstName }} {{ emp.lastName }} ({{ getDeptName(emp.departmentId) }})</span>
              <span class="adm-onboard-pct" *ngIf="hasOnboardingChecklist(emp)"
                [class.adm-pct-green]="getOnboardingProgress(emp) >= 70"
                [class.adm-pct-amber]="getOnboardingProgress(emp) >= 40 && getOnboardingProgress(emp) < 70"
                [class.adm-pct-blue]="getOnboardingProgress(emp) < 40">
                {{ getOnboardingProgress(emp) }}%
              </span>
              <span class="adm-onboard-nochecklist" *ngIf="!hasOnboardingChecklist(emp)">No checklist</span>
            </div>
            <div class="adm-bar-track" *ngIf="hasOnboardingChecklist(emp)">
              <div class="adm-bar-fill"
                [class.adm-bar-green]="getOnboardingProgress(emp) >= 70"
                [class.adm-bar-amber]="getOnboardingProgress(emp) >= 40 && getOnboardingProgress(emp) < 70"
                [class.adm-bar-blue]="getOnboardingProgress(emp) < 40"
                [style.width.%]="getOnboardingProgress(emp)">
              </div>
            </div>
            <div class="adm-onboard-pending">
              {{ hasOnboardingChecklist(emp) ? 'Pending: ' + getOnboardingPending(emp) : 'Click to assign an onboarding checklist' }}
            </div>
          </button>
          <div class="pa-empty" *ngIf="newJoinersOnboardedHere.length === 0">No new joiners onboarded through NovarcPulse this month</div>
        </div>
        <div class="adm-footer-link" (click)="navigateTo('/onboarding')">Manage Onboarding</div>
      </div>

    </div>

  </ng-container>

  <ng-container *ngIf="isHR() && !isAdmin()">

    <div class="stat-row">
      <div class="stat-card sc-maroon adm-card-click" (click)="navigateTo('/employees')" title="Open employee directory">
        <div class="sc-ic"><mat-icon>people_outline</mat-icon></div>
        <div class="sc-label">TOTAL EMPLOYEES</div>
        <div class="sc-value">{{ totalEmployees }}</div>
        <div class="sc-sub">HR &amp; Operations</div>
      </div>
      <div class="stat-card sc-green adm-card-click" (click)="navigateTo('/attendance', { tab: 'admin', status: 'present' })" title="See today's present list">
        <div class="sc-ic"><mat-icon>check_circle_outline</mat-icon></div>
        <div class="sc-label">PRESENT TODAY</div>
        <div class="sc-value">{{ presentToday }}</div>
        <div class="sc-sub">{{ attendanceRate }}% attendance</div>
      </div>
      <div class="stat-card sc-dgreen adm-card-click" (click)="navigateTo('/leaves')" title="Review pending leave requests">
        <div class="sc-ic"><mat-icon>event_note</mat-icon></div>
        <div class="sc-label">LEAVE REQUESTS</div>
        <div class="sc-value">{{ pendingLeaveCount }}</div>
        <div class="sc-sub">Awaiting review</div>
      </div>
      <div class="stat-card sc-teal adm-card-click" (click)="navigateTo('/onboarding')" title="Open onboarding">
        <div class="sc-ic"><mat-icon>person_add</mat-icon></div>
        <div class="sc-label">ONBOARDING DUE</div>
        <div class="sc-value">{{ newThisMonth }}</div>
        <div class="sc-sub">This month</div>
      </div>
    </div>

    <div class="admin-row3 mb16">
      <div class="card">
        <div class="ch">Leave Requests — Pending <span class="ch-link" (click)="navigateTo('/leaves')">All Requests →</span></div>
        <div class="hr-leave-list">
          <ng-container *ngFor="let lv of pendingLeavesList">
            <div class="hr-leave-item">
              <div class="av-1" [style.background]="getAvatarColor(getEmployeeName(lv.employeeId))">{{ getEmployeeInitials(lv.employeeId) }}</div>
                <div class="hr-leave-info">
                  <div class="hr-leave-name">{{ getEmployeeName(lv.employeeId) }} <span class="hr-leave-dept">· {{ getDeptName(lv.employeeId) }}</span></div>
                  <div class="hr-leave-detail">{{ lv.leaveType | titlecase }} · {{ lv.startDate }} to {{ lv.endDate }} · {{ lv.reason || 'No reason' }}</div>
                </div>
              <div class="hr-leave-actions">
                <button class="pa-btn" (click)="navigateTo('/leaves')"><mat-icon style="font-size:13px;width:13px;height:13px">check</mat-icon> Review</button>
              </div>
            </div>
          </ng-container>
          <div class="pa-empty" *ngIf="pendingLeavesList.length === 0">No pending leave requests</div>
        </div>
      </div>
      <div class="admin-right">
        <div class="card">
          <div class="ch">Onboarding Pipeline <span class="ch-link" (click)="navigateTo('/employees')">View All →</span></div>
          <ng-container *ngFor="let emp of newJoiners.slice(0, 3)">
            <div class="srow">
              <span class="srlab">{{ emp.firstName }} {{ emp.lastName }} <span style="font-size:10px;color:#a07055">· {{ getDeptName(emp.departmentId) }}</span></span>
              <span class="bd bgr" style="font-size:10px">New</span>
            </div>
          </ng-container>
          <div class="pa-empty" *ngIf="newJoiners.length === 0">No pending onboarding</div>
        </div>
        <div class="card">
          <div class="ch">Late Arrivals Today</div>
          <ng-container *ngFor="let a of lateAttendance.slice(0, 3)">
            <div class="srow">
              <span class="srlab">{{ getEmployeeName(a.employeeId) }}</span>
              <span class="bd bam" style="font-size:10px">Late</span>
            </div>
          </ng-container>
          <div class="pa-empty" *ngIf="lateAttendance.length === 0">No late arrivals today</div>
        </div>
      </div>
    </div>

    <div class="admin-row4">
      <div class="card">
        <div class="ch">Teams at a Glance <span class="ch-link" (click)="navigateTo('/shifts')">Manage Teams →</span></div>
        <div class="team-list">
          <div class="tg-item" *ngFor="let t of teams.slice(0, 5)">
            <div class="tg-info">
              <div class="tg-name">{{ t.name }}</div>
              <div class="tg-sub">Lead: {{ getEmployeeName(t.teamLeadId) }}</div>
            </div>
            <div style="display:flex;align-items:center;gap:6px">
              <span class="bd bgr" style="font-size:10px">Active</span>
              <button class="tg-edit-btn" (click)="editTeam(t)" title="Edit team" *ngIf="permissions.canEditInModule('teams')">
                <mat-icon style="font-size:14px;width:14px;height:14px">edit</mat-icon>
              </button>
            </div>
          </div>
          <div class="tg-item" *ngIf="teams.length === 0"><div class="tg-sub" style="color:#a07055">No teams yet</div></div>
        </div>
      </div>
      <div class="card">
        <div class="ch">Weekly Attendance <span class="ch-sub">{{ calendarMonth }}</span></div>
        <div class="weekly-placeholder">
          <div class="wp-days"><span>MON</span><span>TUE</span><span>WED</span><span>THU</span><span>FRI</span><span>SAT</span><span>SUN</span></div>
          <div class="wp-bars">
            <div class="wp-bar" *ngFor="let d of weeklyData" [style.height.%]="d" [class.low]="d < 50" [class.zero]="d === 0"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="todayBirthdays.length > 0" style="margin-top:16px;padding:16px 20px">
      <div class="ch" style="margin-bottom:10px"><mat-icon style="vertical-align:middle;margin-right:6px;color:#e91e8c">cake</mat-icon>Birthdays Today</div>
      <div class="ru-list">
        <div class="ru-item" *ngFor="let emp of todayBirthdays">
          <div class="ru-ic" style="background:rgba(233,30,140,.12);color:#e91e8c">
            <mat-icon style="font-size:14px;width:14px;height:14px">cake</mat-icon>
          </div>
          <div class="ru-info">
            <div class="ru-title">{{ emp.firstName }} {{ emp.lastName }}</div>
            <div class="ru-sub">{{ emp.designation || emp.departmentName || '' }} · Happy Birthday!</div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>

</div>

<div class="modal-overlay" *ngIf="showTeamDialog" (click)="closeTeamDialog()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-hd">
      <span class="modal-title">{{ editingTeam ? 'Edit Team' : 'Add Team' }}</span>
      <button class="modal-close" (click)="closeTeamDialog()"><mat-icon style="font-size:16px;width:16px;height:16px">close</mat-icon></button>
    </div>
    <div class="fg">
      <label class="fl">Team Name *</label>
      <input type="text" class="fi" [(ngModel)]="teamForm.name" placeholder="Enter team name">
    </div>
    <div class="fg">
      <label class="fl">Team Lead *</label>
      <app-custom-select [(ngModel)]="teamForm.teamLeadId"
        [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select team lead"></app-custom-select>
    </div>
    <div class="fg">
      <label class="fl">Department</label>
      <app-custom-select [(ngModel)]="teamForm.departmentId"
        [options]="departments" bindLabel="name" bindValue="id" placeholder="Select department"></app-custom-select>
    </div>
    <div class="modal-actions">
      <button class="btn-primary" (click)="saveTeam()" [disabled]="!teamForm.name || !teamForm.teamLeadId">
        {{ editingTeam ? 'Update Team' : 'Create Team' }}
      </button>
      <button class="btn-outline" (click)="closeTeamDialog()">Cancel</button>
    </div>
  </div>
</div>

<div class="modal-overlay emp-modal-overlay" *ngIf="showEmployeeModal && modalEmployee" (click)="closeEmployeeModal()">
  <div class="emp-modal" (click)="$event.stopPropagation()">

    <div class="emp-modal-header">
      <div class="emp-modal-avatar" [style.background]="getAvatarColor(modalEmployee.firstName)">
        {{ (modalEmployee.firstName?.charAt(0)||'') + (modalEmployee.lastName?.charAt(0)||'') | uppercase }}
      </div>
      <div class="emp-modal-info">
        <div class="emp-modal-name">{{ modalEmployee.firstName }} {{ modalEmployee.lastName }}</div>
        <div class="emp-modal-meta">{{ modalEmployee.designation || '—' }} · {{ getDeptName(modalEmployee.departmentId) }}</div>
        <div class="emp-modal-meta">{{ modalEmployee.email }}</div>
      </div>
      <div class="emp-modal-badges">
        <span class="mgr-emp-id">{{ modalEmployee.employeeId || '—' }}</span>
      </div>
      <button class="modal-close emp-modal-close" (click)="closeEmployeeModal()"><mat-icon style="font-size:16px;width:16px;height:16px">close</mat-icon></button>
    </div>

    <div class="emp-section-title">Attendance — {{ calendarMonth }}</div>
    <div class="emp-att-stats">
      <div class="emp-att-box emp-att-present">
        <div class="emp-att-val">{{ modalEmployeeAttStats.present }}</div>
        <div class="emp-att-lbl">Present</div>
      </div>
      <div class="emp-att-box emp-att-late">
        <div class="emp-att-val">{{ modalEmployeeAttStats.late }}</div>
        <div class="emp-att-lbl">Late</div>
      </div>
      <div class="emp-att-box emp-att-leave">
        <div class="emp-att-val">{{ modalEmployeeAttStats.leave }}</div>
        <div class="emp-att-lbl">On Leave</div>
      </div>
      <div class="emp-att-box emp-att-absent">
        <div class="emp-att-val">{{ modalEmployeeAttStats.absent }}</div>
        <div class="emp-att-lbl">Absent</div>
      </div>
      <div class="emp-att-box emp-att-total">
        <div class="emp-att-val">{{ modalEmployeeAttStats.workingDays }}</div>
        <div class="emp-att-lbl">Working Days</div>
      </div>
    </div>

    <div class="emp-section-title" style="margin-top:16px">
      Leave History
      <span class="emp-leave-chips">
        <span class="elc elc-approved">{{ modalEmployeeLeaveStats.approved }} Approved</span>
        <span class="elc elc-pending">{{ modalEmployeeLeaveStats.pending }} Pending</span>
        <span class="elc elc-rejected">{{ modalEmployeeLeaveStats.rejected }} Rejected</span>
      </span>
    </div>
    <div class="emp-leave-list" *ngIf="modalEmployeeLeaves.length > 0">
      <div class="emp-leave-item" *ngFor="let lv of modalEmployeeLeaves.slice(0,10)">
        <div class="emp-leave-type">{{ lv.leaveType | titlecase }}</div>
        <div class="emp-leave-dates">{{ lv.startDate }} –{{ lv.endDate }}</div>
        <div class="emp-leave-reason">{{ lv.reason || 'No reason provided' }}</div>
        <span class="live-badge"
          [class.ontime-badge]="lv.status === 'approved'"
          [class.absent-badge]="lv.status === 'rejected'"
          [class.leave-badge]="lv.status === 'pending'">
          {{ lv.status | titlecase }}
        </span>
      </div>
    </div>
    <div class="pa-empty" *ngIf="modalEmployeeLeaves.length === 0">No leave records found for this employee.</div>

  </div>
</div>

<div class="lv-modal-overlay" *ngIf="showApprovalModal" (click)="showApprovalModal = false"></div>
<div class="lv-approval-modal" *ngIf="showApprovalModal">
  <div class="lv-modal-head" [class.lv-modal-head--reject]="approvalAction === 'rejected'">
    <div class="lv-modal-icon">
      <mat-icon>{{ approvalAction === 'approved' ? 'check_circle' : 'cancel' }}</mat-icon>
    </div>
    <div>
      <div class="lv-modal-title">{{ approvalAction === 'approved' ? 'Approve Leave' : 'Reject Leave' }}</div>
      <div class="lv-modal-sub" *ngIf="approvalLeave">
        {{ approvalLeave.employeeName || getEmployeeName(approvalLeave.employeeId) }} ·
        {{ approvalLeave.leaveType | titlecase }} ·
        {{ approvalLeave.startDate }} – {{ approvalLeave.endDate }}
      </div>
    </div>
    <button class="lv-modal-close" (click)="showApprovalModal = false"><mat-icon>close</mat-icon></button>
  </div>

  <div class="lv-modal-reason" *ngIf="approvalLeave?.reason">
    <span class="lv-modal-reason-label">Employee's reason:</span>
    <span class="lv-modal-reason-text">{{ approvalLeave.reason }}</span>
  </div>

  <div class="lv-modal-field">
    <label class="lv-modal-label">
      Note / Comment
      <span *ngIf="approvalAction === 'rejected'" class="lv-modal-req">* required for rejection</span>
    </label>
    <textarea class="lv-modal-textarea" [(ngModel)]="approvalNote" rows="3"
              [placeholder]="approvalAction === 'approved' ? 'Optional note for the employee…' : 'Reason for rejection (required)…'"></textarea>
    <span class="lv-modal-err" *ngIf="approvalAction === 'rejected' && !approvalNote.trim()">
      Please provide a reason for rejection.
    </span>
  </div>

  <div class="lv-modal-actions">
    <button class="lv-btn-cancel" (click)="showApprovalModal = false" [disabled]="approvalSubmitting">Cancel</button>
    <button class="lv-btn-confirm"
            [class.lv-btn-confirm--approve]="approvalAction === 'approved'"
            [class.lv-btn-confirm--reject]="approvalAction === 'rejected'"
            (click)="confirmApproval()"
            [disabled]="approvalSubmitting || (approvalAction === 'rejected' && !approvalNote.trim())">
      <mat-spinner *ngIf="approvalSubmitting" diameter="14" style="display:inline-block;margin-right:6px"></mat-spinner>
      <ng-container *ngIf="!approvalSubmitting">
        <mat-icon>{{ approvalAction === 'approved' ? 'check_circle' : 'cancel' }}</mat-icon>
        {{ approvalAction === 'approved' ? 'Confirm Approve' : 'Confirm Reject' }}
      </ng-container>
    </button>
  </div>
</div>

